export default __webpack_public_path__ + "static/media/avatar_4.03476916.svg";